<!--
/**
  * 表格操作按钮和描述组件
  * @date 2023-06-15
  使用说明：
    hasTableBtns(true|*false) 表格是否拥有操作按钮行
    hasDesc(*true|false) 表格是否拥有文字描述行
    tableTopBtns(Array) 操作按钮数组
    descInfo(String) 使用组件内默认的文字描述和样式时，要设置文字描述的内容
    slotName(String) 使用slot方式时，要设置slot名称，与业务页面的插槽模板名称一致
  */
-->
<template>
  <div class="top-box">
    <div v-if="hasTableBtns" style="display: flex;">
      <span
          v-for="(item,index) in tableTopBtns"
          :key="index"
        >
          <el-upload
            v-if="item.upload == 'upload'"
            ref="file"
            :on-success="handleTemplateImport"
            class="upload-demo"
            :action="item.importUrl"
            :show-file-list="false"
            :with-credentials="true"
            style="height: 0"
          >
          <el-button v-reClick
            :plain="item.plain==false?false:true"
            :type="item.type || 'primary'"
            :icon="item.icon || ''"
            :size="item.size || 'medium'"
            :disabled="item.disabled || false"
            >{{ item.text }}</el-button>
        </el-upload>
        <el-button v-else v-reClick
          :plain="item.plain==false?false:true"
          :type="item.type || 'primary'"
          :icon="item.icon || ''"
          :size="item.size || 'medium'"
          :disabled="item.disabled || false"
          @click="item.operationFn()"
          >{{ item.text }}</el-button
        >
      </span>
    </div>
    <div v-if="hasDesc || tabs" class="table-desc">
      <div v-if="hasDesc && !slotName">
        <!-- <slot name="tableDesc"></slot> -->
        <div slot="tableDesc" class="tips">
        <img alt="" />
              <span style="color: #333; margin-left: 0.06rem"
                >{{ descInfo }}</span>
        </div>
      </div>
      <div v-if="hasDesc && slotName">
          <slot :name="slotName"></slot>
      </div>
      <div v-if="tabs">
        <slot name="tabs"></slot>
      </div>
    </div>
    <div v-else class="table-nodesc"></div>

  </div>

</template>

<script>
export default {
  name: 'EXTableTopBtnDesc',
  components: {
  },
  data() {
    return {
    };
  },
  props: {
    hasTableBtns: {
      type: Boolean,
      default: false,
    },
    hasDesc: {
      type: Boolean,
      default: true,
    },
    tableTopBtns: {
      type: Array,
    },
    tabs: {
      type: Boolean,
      default: false,
    },
    descInfo: {
       type: String
    },
    slotName: {
      type: String
    }
  },
  methods:{
    // 导入模板成功回调
    handleTemplateImport(res, file) {
      if (res.success) {
        this.$message.success(`当前文件${file.name} , ${res.msg}`)
        this.tableTopBtns.forEach(element => {
            if(element.upload == 'upload'){
              if(element.operationFn){
                element.operationFn()
              }
            }
        });
      } else {
        this.$message.error(`当前文件 ${file.name} 导入失败 , ${res.msg}`)
      }
    },
  }
};
</script>

<style lang="scss" scoped>
@import '../../styles/variables.scss';
/deep/ .el-button {
  height: .36rem;
  min-width: .86rem;
  display: flex;
  margin-right: .05rem;
  align-items: center;

  color: rgb(0, 98, 185);
  background: rgb(229, 241, 255);
  border: 0.01rem solid rgb(109, 163, 227);

  i {
    // font-size: .16rem;
  }
  span {
    // font-size: .16rem;
    margin-left: .05rem;
  }
}
.top-box{
  width: 100%;
}
.table-desc {
  width: 100%;
  padding-left: .14rem;
  padding-right: .2rem;
  margin: .1rem 0;
  height: .44rem;
  line-height: .44rem;
  display: flex;
  justify-content: space-between;
  @include top_desc_bg($top-desc-bgD);
  @include top_desc_border($top-desc-borderD);
  span {
    // font-size: .18rem;
    // font-family: Microsoft YaHei;
    font-weight: 400;
  }
}
.table-nodesc{
  margin: .1rem 0;
}
.tips {
  display: flex;
  align-items: center;
  img{
    width: .16rem;
    @include top_desc_img('tip.png');
  }
}
</style>



// WEBPACK FOOTER //
// src/components/EXTable-top-btn-desc/index.vue